import { render, staticRenderFns } from "./ClassSelect.vue?vue&type=template&id=322f7a54&"
import script from "./ClassSelect.vue?vue&type=script&lang=js&"
export * from "./ClassSelect.vue?vue&type=script&lang=js&"
import style0 from "./ClassSelect.vue?vue&type=style&index=0&id=322f7a54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports